import {
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Router} from '@angular/router';
import {ModalLayoutComponent} from '@paperlessio/sdk/modal-layout';
import {ModalRoutingService} from './modal-routing.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnChanges, OnDestroy, AfterContentInit {
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'full' = 'md';
  @Input() classes = '';
  @Input() header = true;
  @Input() footer = true;
  @Input() centerVertical = false;
  @Input() closable = true;

  @Output() closing = new EventEmitter<void>();

  public elementRef = inject(ElementRef);
  private router = inject(Router);
  private modalLayoutComponent = inject(ModalLayoutComponent, {optional: true});
  private modalRoutingService = inject(ModalRoutingService);

  ngOnInit() {
    if (!!this.modalLayoutComponent) {
      this.modalLayoutComponent.size = this.size;
      this.modalLayoutComponent.classes = this.classes;
      this.modalLayoutComponent.centerVertical = this.centerVertical;
    }
  }

  @HostListener('window:keydown.escape')
  hide(skipLocationChange = false) {
    this.modalRoutingService.reset();
    return this.router.navigate(['', {outlets: {modal: null}}], {skipLocationChange, queryParamsHandling: 'preserve'});
  }

  ngOnDestroy(): void {
    this.closing.emit();
    if (!!this.modalLayoutComponent) {
      this.modalLayoutComponent.size = 'md';
      this.modalLayoutComponent.centerVertical = false;
    }
  }

  ngOnChanges(changes:SimpleChanges): void {
    if (!!this.modalLayoutComponent && changes.size) {
      this.modalLayoutComponent.size = this.size;
      this.modalLayoutComponent.classes = this.classes;
      this.modalLayoutComponent.centerVertical = this.centerVertical;
      this.modalLayoutComponent.cdr.detectChanges();
    }
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      const el = this.elementRef.nativeElement.getElementsByTagName('input')[0];
      if (el) {
        el.focus();
      }
    });
  }

  async back() {
    this.canGoBack ? await this.modalRoutingService.back() : await this.hide();
  }

  get canGoBack() {
    return this.modalRoutingService.canGoBack;
  }
}
